import { render, staticRenderFns } from "./AsetTakBerwujudPage.vue?vue&type=template&id=ba3b1d48"
import script from "./AsetTakBerwujudPage.vue?vue&type=script&lang=js"
export * from "./AsetTakBerwujudPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports